class BoatContact {
    constructor() {
        this.countrySelect = document.getElementById('boat-contact_country-select')
        this.contactFormContainer = document.getElementById('boat-contact_form')
        this.dealerContainer = document.getElementById('boat-contact_dealer-container')
        this.dealerSelectContainer = document.getElementById('boat-contact_dealer-select-container')
        this.dealerSelect = this.dealerSelectContainer?.querySelector('select')
        this.dealerInput = document.getElementById('boat-contact_dealer-input')
        this.countryInput = document.getElementById('boat-contact_country-input')
        this.pleaseSelectDealerLabel = document.getElementById('boat-contact_select-dealer-label').textContent
        this.fetchedDealers = []

        this.registerEventHandlers()
        this.checkFormVisibility()
    }

    static get dealerSearchUrl() {
        //return '/boat-contact-modal.json'
        return '/services/dealer-portal/address/search';
    }

    registerEventHandlers() {
        this.countrySelect?.addEventListener('change', () => this.onCountrySelectChange())
        this.dealerSelect?.addEventListener('change', () => this.onDealerSelectChange())
    }

    checkFormVisibility() {
        if (this.countryInput.value.length > 0) {
            this.contactFormContainer.style.display = "block"
            this.selectOptionOfSelect(this.countrySelect, this.countryInput.value)
        }

        if (this.dealerInput.value.length > 0) {
            this.dealerSelectContainer.style.display = "block"
            this.selectOptionOfSelect(this.dealerSelect, this.dealerInput.value)
        }
    }

    selectOptionOfSelect(selectElement, value) {
        selectElement.value = value;
    }

    onCountrySelectChange() {
        this.countrySelect.disabled = true
        this.countryInput.value = this.countrySelect.value
        this.resetDomState()
        // todo: set hidden language input

        this.fetchDealer()
            .then(response => response.json())
            .then((data) => {
                let dealers = data?.addresses;

                this.countrySelect.disabled = false
                this.fetchedDealers = dealers

                if (dealers.length === 1) {
                    this.dealerSelectContainer.style.display = "none"
                    this.renderDealer(dealers[0])
                    this.contactFormContainer.style.display = "block"
                } else if(dealers.length === 0) {
                    this.contactFormContainer.style.display = "block"
                } else {
                    this.renderDealerSelect(dealers)
                }
            })
    }

    onDealerSelectChange() {
        const dealerSelect = this.dealerSelectContainer.querySelector('select')
        const dealerIdentifier = dealerSelect.value

        if (dealerIdentifier.length === 0) {
            return
        }

        this.renderDealer(this.getDealerByIdentifier(dealerIdentifier))
        this.contactFormContainer.style.display = 'block'
    }

    resetDomState(){
        this.dealerContainer.innerHTML = ''
        this.dealerInput.value = ''
        this.dealerSelectContainer.style.display = "none"
        this.contactFormContainer.style.display = "none"
    }

    getDealerByIdentifier(identifier) {
        if (this.fetchedDealers.length === 0) {
            console.error('No dealers fetched or found')
            return
        }

        return this.fetchedDealers.find(dealer => dealer.identifier === identifier)
    }

    renderDealerSelect(dealers) {
        let dealerOptions = `<option value="">${this.pleaseSelectDealerLabel}</option>`;

        if (!Array.isArray(dealers)) {
            console.error('Dealers is not an array')
            return;
        }

        dealers.forEach((dealer) => {
            dealerOptions+= `
                <option value="${dealer.identifier}">${dealer.vendor}</option>
            `
        })

        this.dealerSelectContainer.querySelector('select').innerHTML = dealerOptions
        this.dealerSelectContainer.style.display = "block"
    }

    renderDealer(dealer) {
        this.dealerInput.value = dealer.identifier

        this.dealerContainer.innerHTML = `
            <p class="copy mt-4">
                <strong>${dealer.vendor}</strong><br>
                ${dealer.street}, ${dealer.postCode} ${dealer.city}, ${dealer.country.country}<br>
                <a href="tel:${dealer.phone}">${dealer.phone}</a><br>
                <a href="mailto:${dealer.email}">${dealer.email}</a>
            </p>
        `
    }

    fetchDealer() {
        const requestData = {
            'country': this.countrySelect.value
        }

        return fetch(BoatContact.dealerSearchUrl + '?' + new URLSearchParams(requestData), {mode: 'no-cors'})
    }
}

document.addEventListener("DOMContentLoaded", function(event) {
    if (document.getElementById('boat-contact_form') != null) {
        const boatContact = new BoatContact()
    }
});
